// extracted by mini-css-extract-plugin
export default {"root":"LeftWidget_root__yqePf","label":"LeftWidget_label__aTuCn","item":"LeftWidget_item__94CIg"};